'use strict';

var React = require('react');
var ReactDOM = require('react-dom');
var styleHelper = require('../../helper/styleHelper');
var convertHelper = require('../../types/convertHelper');
var appTypes = require('../../types/appTypes');
var VerticalScrollBar = require('../common/VerticalScrollBar');
var GlobalConst = require('../../types/GlobalConst');
var linkHelper = require('../common/LinkHelper');
var RuntimeOptions = require('../RuntimeOption.js');
var util = require('../../helper/util');

/***
 * 每一个项
 */
var AccordionItem = React.createClass({
  render: function () {
    var offsetX = 20 * this.props.leave + 6;
    var haveAction = this.props.actionData.link != undefined || this.props.actionData.entry != undefined || this.props.actionData.externalURL != undefined;
    var isLinkAction = this.props.actionData.link != undefined || this.props.actionData.externalURL != undefined;
    var clz = 'no-link';
    if (haveAction) {
      if (isLinkAction){
        clz = 'page-link';
      }else{
        clz = 'interactive-link';
      }
    }
    var AccordionItemStyle = {
      paddingLeft: offsetX,
      //borderBottomStyle:  this.props.leave === 0 ?'solid':'none',
      //borderColor: GlobalConst.GLOBAL_COLOR.SYSTEM_BLANK,
      backgroundColor: this.props.color
    }
    if(this.props.showSeparator){
      AccordionItemStyle.borderBottom = '1px solid ' + this.props.separatorColor;
    }else{
      AccordionItemStyle.borderBottom = '1px solid ' + 'rgba(0,0,0, 0)';
    }

    return (<div
      className="AccordionItem"
      id={this.props.controlID + '_' + this.props.index}
      style={AccordionItemStyle}
      onClick={this.onSelfClick}
      onDoubleClick={this.onSelfDblClick}
      onMouseDown={this.onSelfMouseDown}
      onMouseUp={this.onSelfMouseUp}
    >
      <label>{util.Text.convertSpaceToNbsp(this.props.title)}</label>
      <div className={clz}
           style={{
             width: '100%',
             height: '100%',
             top: 0,
             left: 0,
             position: 'absolute',
             zIndex: 1,
             cursor: haveAction ? 'pointer' : 'default'
           }}
      ></div>
    </div>);
  },
  onSelfClick: function (e) {
    var k;

    if (this.longPress) {
      return;
    }
    if (this.props.actionData) {
      k = appTypes.ActionResponseType.NONE;
      if (this.props.actionData.externalURL) {
        k = appTypes.ActionResponseType.OUTER;
      } else if (this.props.actionData.link) {
        k = appTypes.ActionResponseType.LINK;
      } else if (this.props.actionData.entry) {
        k = appTypes.ActionResponseType.INTERACTIVE;
      }
    }
    if (e.button === 0) {
      if (this.props.onClick) {
        this.props.onClick(e, k, this.props.index);
      }
    } else if (e.button === 2) {
      this.onSelfRightClick(e);
    }
  },

  mousePress: false,

  longPressID: undefined,

  longPress: false,

  onSelfDblClick: function (e) {
    if (this.props.onDoubleClick) {
      this.props.onDoubleClick(e, this.props.index);
    }
  },

  onSelfRightClick: function (e) {
    if (this.props.onRightClick) {
      this.props.onRightClick(e, this.props.index);
    }
  },

  onSelfMouseDown: function (e) {
    this.mousePress = true;
    this.startLongPress(e);
  },

  onSelfMouseUp: function (e) {
    this.mousePress = false;
    this.longPress = false;
    this.stopLongPress();
  },

  stopLongPress: function () {
    if (this.longPressID) {
      clearTimeout(this.longPressID)
    }
    delete this.longPressID;
  },

  startLongPress: function (e) {
    var self = this;
    var data = this.props.actionData;
    var entry;
    if(data){
      entry = data.entry;
    }
    if(linkHelper.hasLongPressByEntry(entry)) {
      this.longPressID = setTimeout(function () {
        if (self.mousePress) {
          self.longPress = true;
          if (self.props.onLongPress) {
            self.props.onLongPress(e, self.props.index);
          }
        }
        self.stopLongPress();
      })
    }
  }

});
/***
 * 每一个分组
 */
var AccordionModule = React.createClass({
  render: function () {
    var h = (this.props.expand ? this.props.childHeight : 0) + 30;
    var boxStyle = {
      height : this.props.expand ? this.props.childHeight: 0
    }
    if(this.props.showSeparator){
      boxStyle.borderBottom = '1px solid ' + this.props.separatorColor;
    }else{
      boxStyle.borderBottom = '1px solid ' + 'rgba(0,0,0, 0)';
    }


    return (
      <div
        className="AccordionModule"
        style={{height : h}}>
        <AccordionItem
          key="title"
          {...this.props}
        />
        <div className="AccordionModule-Box"
             style={boxStyle}>
          {
            this.props.childNode.map(function (node, index) {
              return (<AccordionItem key={index} ref={'subItem-'+index} {...node} />);
            })
          }
          {
            this.props.showScrollBar && (<VerticalScrollBar
              key="scrollbar"
              {...{
                value: parseInt(this.props.scrollPoint, 10),
                right: this.props.w - 1,
                height: '100%',
                zIndex: this.props.childNode.length + 10
              }}/>)
          }
        </div>
      </div>
    );
  },

  componentDidUpdate: function () {
    this.doAdjustSubItemPoint();
  },

  componentDidMount: function () {
    this.doAdjustSubItemPoint();
  },

  doAdjustSubItemPoint: function () {
    var i = 0;
    var subItem;
    var top = 0;
    var itemHeight = 30;
    while (true) {
      subItem = ReactDOM.findDOMNode(this.refs['subItem-' + i]);
      if (!subItem) {
        break;
      }
      $(subItem).css({top: top});
      top += itemHeight;
      i++;
    }
  }
});

/**
 * 折叠面板组件
 * @author mxj
 *
 */
var Accordion = React.createClass({
  propTypes: {
    text: React.PropTypes.string.isRequired
  },

  getInitialState: function () {
    return {
      selectedIndex: parseInt(this.props.selectedIndex, 10)
    };
  },

  /**
   * 解析数据为节点
   * @param items
   * @returns {Array}
   */
  parseTextToNode: function (items) {
    var Items = [];
    var childNode = {};
    var actionDatas = linkHelper.parseComInteractive(this.props);
    for (var i = 0; i < items.length; i++) {
      var item = items[i];
      if (item.charAt(0) != '-') {
        Items.push({
          title: item,
          leave: 0,
          index: i,
          controlID: this.props.controlID,
          expand: i === this.state.selectedIndex,
          color: i === this.state.selectedIndex ? this.props.selectedColor : GlobalConst.GLOBAL_COLOR.TRANSPARENT_COLOR,
          onClick: this.onItemClick,
          actionData: actionDatas[i],
          top: Items.length * 30,
          childNode: []
        });
        if (i === this.state.selectedIndex) {
          this.selectedModuleIndex = Items.length - 1;
        }
      } else {
        childNode = {
          title: item.substring(1),
          leave: 1,
          index: i,
          controlID: this.props.controlID,
          color: i === this.state.selectedIndex ? this.props.selectedColor : GlobalConst.GLOBAL_COLOR.TRANSPARENT_COLOR,
          onClick: this.onItemClick,
          onDblClick: this.onItemDblClick,
          onRightClick: this.onItemRightClick,
          onLongPress: this.onItemLongPress,
          actionData: actionDatas[i],
          top: Items[Items.length - 1].childNode ? Items[Items.length - 1].childNode.length * 30 : 0
        };
        if (i === this.state.selectedIndex) {
          Items[Items.length - 1].expand = true;
          Items[Items.length - 1].color = this.props.selectedColor;
          this.selectedModuleIndex = Items.length - 1;
        }
        Items[Items.length - 1].childNode.push(childNode);
      }
    }
    return Items;
  },

  selectedModuleIndex: 0,

  render: function () {
    var textItems = util.Text.delimitText(util.Text.removeLastEmptyRow(styleHelper.getText(this.props)), util.Text.DM_RETURN);
    var nodes = this.parseTextToNode(textItems);
    var childHeight = (this.props.h - nodes.length * 30) + 2;

    var style = {
      width: '100%',
      height: '100%',
      lineHeight: '30px',
      borderWidth: 1,
      overflow: 'hidden',
      boxSizing: 'border-box',
      position: 'absolute',
      borderColor: GlobalConst.GLOBAL_COLOR.SYSTEM_BLANK
    };
    style = styleHelper.StyleUtil(this.props).background().border().text().align().default(style).style;

    /*border相关修正*/
    if(this.props.borderVisible){
      style.borderWidth = 1;
    }else{
      style.borderWidth = 0;
    }

    if(this.props.borderColor){
      style.borderColor = this.props.borderColor;
    }else{
      style.borderColor = GlobalConst.GLOBAL_COLOR.SYSTEM_BLANK;
    }

    var node;
    for (var i = 0; i < nodes.length; i++) {
      node = nodes[i];
      node.childHeight = childHeight;
      node.showScrollBar = this.props.verticalScrollbarShow;
      node.scrollPoint = this.props.verticalScrollbarProgress;
      node.showSeparator = this.props.showSeparator;
      node.separatorColor = this.props.separatorColor;
    }
    return (

      <div style={style}>
        {
          nodes && nodes.map(function (cnode, index) {
            return (
              <AccordionModule key={index} ref={'module-' + index} {...cnode}/>);
          })
        }
      </div>);
  },

  _onLinkEvent: function (evt, linkKey, index) {
    RuntimeOptions.eventTargetCom = ReactDOM.findDOMNode(this);
    this.props.events.doSelfClick(evt, this.props, linkKey, index);
  },

  onItemClick: function (e, key, index) {
    this.setState({
      selectedIndex: index
    });
    if (this.longPress) {
      return;
    }
    if (e.button === 0) {
      if (key) {
        this._onLinkEvent(e, key, index);
      }
    } else if (e.button === 2) {
      this._onRightClick(e, index);
    }
  },

  onItemDblClick: function (e, index) {
    if (this.props.events.doSelfDbClick) {
      this.props.events.doSelfDbClick(e, this.props, index);
    }
  },

  onItemLongPress: function (e, index) {
    if (this.props.events.doSelfLongPress)
      this.props.events.doSelfLongPress(e, this.props, index);
  },

  onItemRightClick: function (e, index) {
    if (this.props.events.doSelfRightClick) {
      this.props.events.doSelfRightClick(e, this.props, index);
    }
  },

  componentDidMount: function () {
    $(ReactDOM.findDOMNode(this)).bind('itemClick', this.onItemClick);
    this.doAdjustModulePoint();
  },


  componentDidUpdate: function () {
    this.doAdjustModulePoint();
  },

  doAdjustModulePoint: function () {
    var i = 0;
    var refStr;
    var moduleItem;
    var selfDom = ReactDOM.findDOMNode(this);
    var c = selfDom.childElementCount;
    var h = styleHelper.getHeight(this.props);
    var itemHeight = 30;
    var top = 0;
    var moduleHeight = itemHeight * c;
    var subHeight = h - moduleHeight;

    while (true) {
      moduleItem = ReactDOM.findDOMNode(this.refs['module-' + i]);
      if (!moduleItem) {
        break;
      }
      $(moduleItem).css({top: top});
      top += itemHeight;
      if (i === this.selectedModuleIndex) {
        top += subHeight;
      }
      i++;
    }
  }

});

module.exports = Accordion;



// WEBPACK FOOTER //
// ./src/views/Components/Accordion.jsx